import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import SizeTable from "../../elements/Tables/SizeTable/SizeTable";
import SizeCreationForm from "../../elements/Forms/SizeCreationForm/SizeCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_SIZE_API,
} from "../../../Constants/Apis"
import { Button, Flex, Input, message, Modal } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteSize } from "../../../Services/SizeService";

const { Search } = Input;

const SizePage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sizeId, setSizeId] = useState(null);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setSizeId(id);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await deleteSize(sizeId);
      message.success("Size deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete size."
      );
    }
    setIsModalOpen(false);
  };

  const {
    fetchedData: { data },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_SIZE_API}`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  return (
    <div style={{ width: "100vw", padding: "20px", boxSizing: "border-box", display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "50vw",
          maxWidth: "100vw",
        }}
      >
        <Button type="primary" onClick={handleOpenModal}>
          Create New Size
        </Button>
        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: "300px" }}
        />
      </div>

      <SizeTable
        history={history}
        loading={loading}
        data={data}
        callReFetch={callReFetch}
        dispatch={dispatch}
        handleDelete={handleDelete}
      />

      <Modal
        title="Create Size"
        open={isModalVisible}
        footer={null}
        onCancel={handleCloseModal}
      >
        <SizeCreationForm
          history={history}
          userData={userData}
          callReFetch={callReFetch}
          onClose={handleCloseModal}
        />
      </Modal>

      <Modal
        title="Delete Size"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this size?</p>
      </Modal>
    </div>
  );
};

SizePage.propTypes = {};

export default SizePage;
